import { SelectProps } from '@mantine/core';
import { Loader } from 'src/design/atoms/Loader';
import { Select } from 'src/design/atoms/Select';
import React from 'react';
import { useWbs } from 'src/routes/Jobs/WBS/contexts/WbsContext';

type WbsAdjustmentTypeSelectorProps = SelectProps;

export const WbsAdjustmentTypeSelector: React.FC<
  WbsAdjustmentTypeSelectorProps
> = ({ ...props }) => {
  const {
    adjustmentTypes,
    adjustmentTypesLoading,
    adjustmentTypesError,
    loadAdjustmentTypes,
  } = useWbs();

  React.useEffect(() => {
    if (adjustmentTypes.length === 0 && !adjustmentTypesLoading) {
      loadAdjustmentTypes();
    }
  }, [adjustmentTypes.length, adjustmentTypesLoading, loadAdjustmentTypes]);

  const selectData = React.useMemo(() => {
    return adjustmentTypes.map((type) => ({
      value: type.id,
      label: type.name,
    }));
  }, [adjustmentTypes]);

  if (adjustmentTypesLoading) {
    return (
      <Select
        {...props}
        placeholder="Loading adjustment types..."
        disabled
        leftSection={<Loader size="xs" />}
      />
    );
  }

  if (adjustmentTypesError) {
    return (
      <Select
        {...props}
        placeholder="Error loading adjustment types"
        disabled
        error={adjustmentTypesError}
      />
    );
  }

  return <Select data={selectData} searchable clearable {...props} />;
};
